import { render, staticRenderFns } from "./changeGoods.vue?vue&type=template&id=629efcee&scoped=true"
import script from "./changeGoods.vue?vue&type=script&lang=js"
export * from "./changeGoods.vue?vue&type=script&lang=js"
import style0 from "./changeGoods.vue?vue&type=style&index=0&id=629efcee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629efcee",
  null
  
)

export default component.exports